// extracted by mini-css-extract-plugin
export default {"modalHeader":"info-popup-module--modal-header--713e0","modalHeaderWithClose":"info-popup-module--modal-header-with-close--9f4fc","closeBtn":"info-popup-module--close-btn--195a2"};